import { Component } from '@angular/core';
import { TableTypeCompte } from '../../../../../data/schemas/table.schema';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppService } from '../../../../../core/app.service';
import { TypeCompteService } from '../../../../../services/typecompte.service';
import { UiTable } from '../../../../../components/ui/table/table.component';
import { ModalComponent } from '../../../../../components/modal/modal.component';
import { Input } from '../../../../../components/forms/input/input';
import { LoaderComponent } from '../../../../../components/ui/loader/loader.component';
import { MatIcon } from '@angular/material/icon';
import { transformString } from '../../../../../utils/helpers';
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';
import { SelectComponent } from '../../../../../components/forms/select/select.component';
import { SelectOption } from '../../../../../data/schemas/selectoption.schema';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';



@Component({
  selector: 'app-typecompte',
  imports: [UiTable, ModalComponent,SelectComponent , ReactiveFormsModule, Input, LoaderComponent, MatIcon, UiButtonComponent,
  loaderIntervantion,
  ConfirmDialogComponent, SelectComponent],
  templateUrl: './typecompte.component.html',
  styleUrl: './typecompte.component.css'
})
export class TypecomptePage {
  public tableEntity = TableTypeCompte
  public showAddEntityModal: boolean = false;
  public entities : any[] = []
  public isLoading: boolean = false;
  public typeComptes: SelectOption[] = [];
  public isEditing: boolean = false; // Nouvelle propriété pour suivre l'état d'édition
  public editingEntity: any | null = null;
  public showDeleteConfirm: boolean = false;
  public selectedItem: any | null = null;
  public deleteLoading: boolean = false;

  public isAddParent: boolean = true;          // indique si on ajoute un compte parent
  public parentEntity: any | null = null;      // parent choisi pour un sous-compte

  /* Champs */
  entityForm!: FormGroup;

  constructor(
    private entityService: TypeCompteService,
    private fb: FormBuilder,
    private AppService: AppService
  ){
    this.entityForm = this.fb.group({
      applicationId: this.AppService.getAppId()!,
      libelle: ['', [Validators.required]],
      parentId: [null],
      parentDisplay: ['']
    });
  }

  ngOnInit(): void {
    this.loadEntities();
    // optionally preload types for the select in modal
    this.loadTypeComptes().subscribe();
  }

  saveEntity(): void {
    if (this.entityForm.valid) {
      this.isLoading = true;
      let requestBody: any = this.entityForm.value;

      // if adding a sub-account, include parentId
      if (!this.isAddParent && this.parentEntity) {
        requestBody.parentId = this.parentEntity.id;
      }

      requestBody = {
        ...requestBody,
        code: transformString(this.entityForm.value.libelle)
      }

      if (this.isEditing && this.editingEntity) {
        // Logique de mise à jour
        this.entityService.update(this.editingEntity.id, requestBody).subscribe({
          next: () => {
            this.loadEntities();
            this.closeAddEntityModal(); // Appel à la méthode renommée
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur lors de la mise à jour de la ligne budgétaire :', error);
            this.isLoading = false;
          }
        });
      } else {
        // Logique de création existante
        this.entityService.create(requestBody).subscribe({ // Utilise requestBody
          next: () => {
            this.entityForm.reset({
              applicationId: this.AppService.getAppId()!,
              libelle: '',
            });
            this.loadEntities();
            this.closeAddEntityModal(); // Appel à la méthode renommée
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur lors de la création de la ligne budgétaire :', error);
            this.isLoading = false;
          }
        });
      }
    } else {
      this.entityForm.markAllAsTouched();
      console.warn('Le formulaire de ligne budgétaire est invalide.');
    }
  }

  loadEntities(): void {
    this.entityService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.entities = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  // Renommée en openAddLigneBudgetaireModal
  openAddEntityModal(isAddParent: boolean = true, parent?: any): void {
    this.isAddParent = isAddParent;
    this.parentEntity = parent || null;
    this.isEditing = false; // S'assurer que nous sommes en mode ajout
    this.editingEntity = null;
    // Préparer les valeurs initiales du formulaire selon le contexte
    this.entityForm.reset({
      applicationId: this.AppService.getAppId()!,
      libelle: '',
      parentId: parent?.id || null,
      parentDisplay: parent ? (parent.intitule || parent.code) : ''
    }); // Réinitialiser le formulaire
    this.showAddEntityModal = true;
  }

  // Renommée en closeAddLigneBudgetaireModal
  closeAddEntityModal(): void {
    this.showAddEntityModal = false;
    this.isEditing = false; // Réinitialiser l'état d'édition
    this.editingEntity = null; // Réinitialiser l'élément en édition
    this.isAddParent = true;
    this.parentEntity = null;
    this.entityForm.reset({
      applicationId: this.AppService.getAppId()!,
      libelle: '',
      parentId: null,
      parentDisplay: ''
    }); // Réinitialiser le formulaire
  }

  onEditEntity(item: any): void {
    this.isEditing = true;
    this.editingEntity = item;
    this.isAddParent = !item.parentId;
    this.parentEntity = item.parent || null;
    this.entityForm.patchValue({
      libelle: item.libelle,
      applicationId: this.AppService.getAppId()!, // Patch l'applicationId si nécessaire, sinon il reste celui du cookie
      parentId: item.parentId || null,
      parentDisplay: item.parent ? (item.parent.intitule || item.parent.code) : ''
    });
    this.showAddEntityModal = true; // Ouvrir le modal
  }

// Remplacer onDeleteEntity par ces trois méthodes
openDeleteConfirm(item: any): void {
  this.selectedItem = item;
  this.showDeleteConfirm = true;
}

cancelDelete(): void {
  this.showDeleteConfirm = false;
  this.selectedItem = null;
}

confirmDelete(): void {
  if (!this.selectedItem) return;
  this.deleteLoading = true;
  this.entityService.delete(this.selectedItem.id).subscribe({
    next: () => {
      this.loadEntities();
      this.deleteLoading = false;
      this.cancelDelete();
    },
    error: (error) => {
      console.error('Erreur suppression :', error);
      this.deleteLoading = false;
    }
  });
}


  onDeleteEntity(item: any): void {
    /* this.ligneBudgetaireService.delete(item.id).subscribe(({
      next: () => {
        this.lignebudgetaireForm.reset({
          applicationId: this.cookiesService.getCookie("appid")!,
          libelle: ''
        });
        this.loadLigneBudgetaire();
        //this.closeAddLigneBudgetaireModal(); // Appel à la méthode renommée
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors de la création de la ligne budgétaire :', error);
        this.isLoading = false;
      }
    })) */
  }

  // chargement des options pour le select "Type de compte" du modal
  loadTypeComptes(): Observable<SelectOption[]> {
    if (this.typeComptes.length > 0) {
      return of(this.typeComptes);
    }
    return this.entityService.getAllByAppId(this.AppService.getAppId()!).pipe(
      map((response: any) => {
        this.typeComptes = response.data.map((item: any) => ({
          value: item.libelle,
          label: item.libelle
        }));
        return this.typeComptes;
      }),
      take(1)
    );
  }
}
